import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import {
    Box,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Typography,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { DatePicker, TimePicker, DateTimePicker } from '@mui/x-date-pickers';

const Frequency = ({ scheduleData, setScheduleData, isPublished, validationErrors = false , isDraft=false }) => {
    const [frequency, setFrequency] = useState(scheduleData?.frequency);
    const [dayName, setDayName] = useState(scheduleData?.dayName);
    const [hourlyVal, setHourlyVal] = useState(scheduleData?.hourlyVal);
    const [loadType, setLoadType] = useState(scheduleData?.loadType);
    const [scheduleTime, setScheduleTime] = useState(
        scheduleData?.scheduleTime
    );
    const [firstExecutionTime, setFirstExecutionTime] = useState(
        scheduleData?.firstExecutionTime || scheduleData?.executionTime
    );

    const frequencyArr = ['DAILY', 'WEEKLY', 'HOURLY'];
    const hourlyArr = [
        'Every Half Hour',
        'Every Hour',
        'Every Two Hour',
        'Every Four Hour',
        'Every Six Hour',
        'Every Eight Hour',
        'Every Twelve Hour',
    ];
    const daysOfWeekArr = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];

    const toLocalISOString = (date) => {
        const tzOffset = date.getTimezoneOffset() * 60000; // in ms
        return new Date(date.getTime() - tzOffset).toISOString();
    };
    const formatToYYYYMMDD = (date1) => {
        let date = date1;
        if (!(date1 instanceof Date)) {
            date = new Date(date1);
        }
        //console.log("date", date);
        if (!date) return null;
        const year = date?.getFullYear();
        const month = String(date?.getMonth() + 1)?.padStart(2, '0'); // getMonth() is 0-indexed
        const day = String(date?.getDate())?.padStart(2, '0');
        return `${year}${month}${day}`;
    };
    const getUTCDateTime = () => {
        const d = new Date();
        const utcDate = new Date(
            d.getUTCFullYear(),
            d.getUTCMonth(),
            d.getUTCDate(),
            d.getUTCHours(),
            d.getUTCMinutes(),
            d.getUTCSeconds(),
            d.getUTCMilliseconds()
        );
        //console.log("utcDate", utcDate);
        return utcDate;
    };
    const getMinTimeVal = () => {
        if (!firstExTime) {
            return null;
        } else if (
            formatToYYYYMMDD(firstExTime) === formatToYYYYMMDD(new Date())
        ) {
            const utcDate = getUTCDateTime();
            return utcDate;
        } else {
            return null;
        }
    };
    const updateState = (field, value) => {
        let obj = { ...scheduleData, [field]: value };
        if (field === 'frequency') {
            setFrequency(value);
        } else if (field === 'dayName') {
            setDayName(value);
        } else if (field === 'hourlyVal') {
            setHourlyVal(value);
        } else if (field === 'loadType') {
            setLoadType(value);
        } else if (field === 'scheduleTime') {
            setScheduleTime(value);
        } else if (field === 'firstExecutionTime') {
            const updatedVal = toLocalISOString(value);
            setFirstExecutionTime(updatedVal);
            if (formatToYYYYMMDD(value) === formatToYYYYMMDD(new Date())) {
                setScheduleTime(null);
                obj = {
                    ...scheduleData,
                    [field]: updatedVal,
                    scheduleTime: null,
                };
            } else {
                obj = { ...scheduleData, [field]: updatedVal };
            }
        }
        console.log('obj::::', obj);
        setScheduleData(obj);
    };

    const firstExTime =
        firstExecutionTime ||
        scheduleData?.firstExecutionTime ||
        scheduleData?.executionTime;

    return (
        <LocalizationProvider>
            <div className="info-container">
                <h4>Mandatory to publish a rule</h4>
            </div>
            <Box sx={{ bgcolor: 'white' }}>
                {/* Frequency */}

                <FormControl fullWidth sx={{ mb: 2 }}>
                    <Typography variant="" color="textPrimary">
                        Frequency
                    </Typography>
                    <Select
                        disabled={isPublished}
                        value={frequency || scheduleData?.frequency}
                        label=""
                        onChange={(e) =>
                            updateState('frequency', e.target.value)
                        }
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor:
                                    validationErrors 
                                    // && !isDraft 
                                    && !scheduleData?.frequency
                                        ? 'red'
                                        : undefined,
                            },
                        }}
                    >
                        {frequencyArr?.map((fr) => {
                            return <MenuItem value={fr}>{fr}</MenuItem>;
                        })}
                    </Select>
                </FormControl>

                {/* Schedule Run Day/Date */}
                {String(frequency)?.toLowerCase() !== 'daily' && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        {String(
                            frequency || scheduleData?.frequency
                        )?.toLowerCase() === 'hourly' && (
                            <>
                                <Typography variant="" color="textPrimary">
                                    {'Schedule Run Hour'}
                                </Typography>
                                <Select
                                    value={hourlyVal || scheduleData?.hourlyVal}
                                    label=""
                                    onChange={(e) =>
                                        updateState('hourlyVal', e.target.value)
                                    }
                                    disabled={isPublished}
                                >
                                    {hourlyArr?.map((hour) => {
                                        return (
                                            <MenuItem value={hour}>
                                                {hour}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </>
                        )}
                        {String(
                            frequency || scheduleData?.frequency
                        )?.toLowerCase() === 'weekly' && (
                            <>
                                <Typography variant="" color="textPrimary">
                                    {'Schedule Run Day'}
                                </Typography>
                                <Select
                                    value={dayName || scheduleData?.dayName}
                                    label=""
                                    onChange={(e) =>
                                        updateState('dayName', e.target.value)
                                    }
                                    disabled={isPublished}
                                >
                                    {daysOfWeekArr?.map((day) => {
                                        return (
                                            <MenuItem value={day}>
                                                {day}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </>
                        )}
                    </FormControl>
                )}
                {/* First Excecution Date */}

                <FormControl fullWidth sx={{ mb: 2 }}>
                    <Typography variant="" color="textPrimary">
                        First Execution Date (UTC Timezone)
                    </Typography>
                    <DatePicker
                        value={firstExTime ? Date.parse(firstExTime) : null}
                        disabled={isPublished}
                        label=""
                        onChange={(newValue) => {
                            //setFirstExecutionTime(newValue);
                            updateState('firstExecutionTime', newValue);
                        }}
                        minDate={getUTCDateTime()}
                        slotProps={{
                            textField: {
                                sx: {
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: validationErrors  
                                        // && !isDraft
                                            ? 'red'
                                            : undefined,
                                    },
                                },
                            },
                        }}
                    />
                </FormControl>
                {/* Schedule Run Time */}
                {String(
                    frequency || scheduleData?.frequency
                )?.toLowerCase() && (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <Typography variant="" color="textPrimary">
                            Schedule Run Time (UTC Timezone)
                        </Typography>
                        <TimePicker
                            ampm={false}
                            closeOnSelect={false}
                            value={Date.parse(
                                scheduleTime || scheduleData?.scheduleTime
                            )}
                            disabled={isPublished}
                            label=""
                            onAccept={(newValue) =>
                                updateState('scheduleTime', newValue)
                            }
                            renderInput={(params) => (
                                <TextField
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    {...params}
                                />
                            )}
                            minTime={getMinTimeVal()}
                        />
                    </FormControl>
                )}

                {/* Load Type */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <Typography variant="" color="textPrimary">
                        Load Type
                    </Typography>
                    <Select
                        disabled={isPublished}
                        value={loadType || scheduleData?.loadType}
                        label=""
                        onChange={(e) =>
                            updateState('loadType', e.target.value)
                        }
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor:
                                    validationErrors 
                                    // && !scheduleData?.loadType
                                        ? 'red'
                                        : undefined,
                            },
                        }}
                    >
                        <MenuItem value="Full">Full</MenuItem>
                        <MenuItem value="Delta">Delta</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Typography variant="" color="textPrimary">
                *If first execution date is current date, then Sehedule run time
                selection can be only future time
            </Typography>
        </LocalizationProvider>
    );
};

export default Frequency;
